import List from "#SRC/js/structs/List";
import PodInstance from "./PodInstance";

class PodInstanceList extends List {}

PodInstanceList.type = PodInstance;

module.exports = PodInstanceList;



// WEBPACK FOOTER //
// ./plugins/services/src/js/structs/PodInstanceList.js